import NavLink from "components/Navlink";
import React from "react";
import IcYeedev from 'assets/icons/ic-yeedev.png'
import IcMap from 'assets/icons/ic-mapFooter.png'
// import IcMail from 'assets/icons/ic-mail.png';
// import IcPhone from 'assets/icons/ic-phone.png'
import IcIg from 'assets/icons/ic-ig.png'
import IcYt from 'assets/icons/ic-yt.png'
import IcFb from 'assets/icons/ic-fbFooter.png'
import IcTw from 'assets/icons/ic-tw.png'
import LogoDesa from 'assets/icons/logo-desa.png'
// import xIcon from 'assets/icons/ic-x.png'

export default function LandingFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="py-10 text-white bg-primary">
      <div className="justify-between px-5 xl:flex xl:px-99">
        <div className="mb-10 xl:mb-0 main lg:w-[515px]">
          <div className="items-center justify-between space-y-10 md:flex __logoWrapper md:space-y-0 lg:w-[415px]">
            <img
              src={LogoDesa}
              alt="logo Geulanggang-Panah"
              width={150}
              height={100}
            />
            {/* <img src={xIcon} alt="logo yeedev" width={20} height={20} /> */}
            <img src={IcYeedev} alt="logo yeedev" width={150} height={100} />
          </div>
          <div className="wrapperDetail lg:w-[515px] my-10 space-y-20">
            <div className="mb-10 xl:mb-0 main lg:w-[415px]">
              <p className="text-justify">
                <span className="font-bold">Geulanggang-Panah</span> adalah inisiatif
                komunitas untuk membangun negeri melalui bagian paling penting;
                yaitu desa.Platform dan inisiatif ini dimulai dan dikembangkan
                oleh YEEDEV STUDIO, tapi perubahan sesungguhnya ada di tangan
                kamu para implementor penggerak desa. Ajak desa kamu menjadi
                Geulanggang-Panah bersama-sama.
              </p>
            </div>
            <div className="flex items-center space-x-5 ">
              <img
                src={IcMap}
                alt="detail alamat yeedevstudio"
                width={30}
                height={30}
              />
              <p>Geulanggang Teungoh, Kota Juang, Bireuen, Aceh</p>
            </div>
            {/* <div
              className="flex items-center space-x-5 place"
              onClick={() =>
                (window.location.href = "mailto:coo.yeedev@gmail.com")
              }
            >
              <img
                src={IcMail}
                alt="detail alamat yeedevstudio"
                width={30}
                height={30}
              />
              <p>coo.yeedev@gmail.com</p>
            </div>
            <div
              className="flex items-center space-x-5 place"
              onClick={() => (window.location.href = "tel:+62822 8592 5477")}
            >
              <img
                src={IcPhone}
                alt="detail alamat yeedevstudio"
                width={30}
                height={30}
              />
              <p>(+62)822 8592 5477</p>
            </div> */}
          </div>
        </div>
        <div className="mt-20 xl:flex-col navMed">
          {/* <div className="mb-10 xl:mb-0 main lg:w-[415px]">
            <p className="text-justify">
              <span className="font-bold">Geulanggang-Panah</span> adalah inisiatif
              komunitas untuk membangun negeri melalui bagian paling penting;
              yaitu desa.Platform dan inisiatif ini dimulai dan dikembangkan
              oleh YEEDEV STUDIO, tapi perubahan sesungguhnya ada di tangan kamu
              para implementor penggerak desa. Ajak desa kamu menjadi desa
              cerdas bersama-sama.
            </p>
          </div> */}
          <div className="mt-8 lg:flex xl:space-x-10">
            <div className="mb-10 navigasi xl:mb-0">
              <h1 className="mb-8 font-bold">Navigasi</h1>
              <div className="space-y-3 text-xs">
                <NavLink route={`/`} title="Cara Bergabung" />
                <NavLink route={`/daftardesa`} title="Desa Terdaftar" />
              </div>
            </div>
            <div className="medsos">
              <h1 className="mb-8 font-bold">Media Sosial</h1>
              <div className="space-x-5">
                <button
                  type="button"
                  onClick={() =>
                    (window.location.href =
                      "https://instagram.com/yeedevstudio")
                  }
                >
                  <img src={IcIg} alt="icon instagram" width={30} height={30} />
                </button>
                <button
                  type="button"
                  onClick={() =>
                    (window.location.href = "https://twitter.com/yeedevstudio")
                  }
                >
                  <img src={IcTw} alt="icon twitter" width={30} height={30} />
                </button>
              </div>
              <div className="mt-3 space-x-5">
                <button
                  type="button"
                  onClick={() =>
                    (window.location.href =
                      "https://www.youtube.com/channel/UCcG5fRxkRWZnj-I4yPA5RXA")
                  }
                >
                  <img src={IcYt} alt="icon instagram" width={30} height={30} />
                </button>
                <button
                  type="button"
                  onClick={() =>
                    (window.location.href =
                      "https://www.facebook.com/yeedevstudio")
                  }
                >
                  <img src={IcFb} alt="icon instagram" width={30} height={30} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lineV bg-white w-full h-[1px] mt-7" />
      <div className="px-5 xl:px-99 mt-7 ">
        <p className="text-xs text-center xl:text-justify font-extralight">
          © {year} Geulanggang-Panah - All Rights Reserved
        </p>
      </div>
    </footer>
  );
}
